import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const authModule = {
    namespaced: true,
    state: {
        setting : {
            ui: {
                is_dark: false,
                navbar_skin: "navbar-info navbar-light",
                sidebar_skin: "sidebar-dark-primary",
                menu_sidebar_collapsed: true
            },
            register: {
                allow_register: true,
                show_role: true,
                auto_active: false
            }
        },
        default : {
            alamat : {
                country : {},
                provinsi : {},
                kota : {},
                kecamatan : {},
                kelurahan : {},
            }
        }
    },
    mutations,
    actions,
    getters
};

export default authModule;
